module.exports = __webpack_public_path__ + "0924ba29e2ffc33095fe9f6e6f013c12.svg";